import React from "react";
import PageWrapper from "./ExternalProvider.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import ExternalProviderTable from "components/ExternalProvider/ExternalProviderTable";

const ExternalProvider = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.external_provider"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.external_provider"
          }
        ]}
      />
      <div className="user-tbl">
        <ExternalProviderTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.permissionReducer,
    ...state.themeChanger,
    authData: {
      token: state.auth.token,
      isLogin: state.auth.isLogin,
      profileImage: state.auth.profile_image,
      adminRoleId: state.auth.admin_role_id,
      adminRole: state.auth.admin_role,
      full_name: state.auth.first_name + " " + state.auth.last_name
    }
  };
};

export default connect(mapStateToProps, null)(ExternalProvider);
